import { Context, CustomQuery } from '@vue-storefront/core';
type RegisterResponse = {
  token: string;
}

export default async function customRegister(context: Context, parms: CustomQuery): Promise<RegisterResponse> {
  const { email, firstName, lastName, password, phone, code, phone_country_code } = parms;
  const username = firstName + '.' + lastName;
  // console.log('customRegister...', parms);

  // Create URL object containing full endpoint URL
  const url = new URL('/mall/member/register', context.config.api.url);

  // // Add parameters passed from composable as query strings to the URL
  // url.searchParams.set('password', password);

  const { data } = await context.client.post(url.href, { phone, email, password, nick: username, first_name: firstName, last_name: lastName, code, phone_country_code });

  // console.log('customRegister res: ', data);

  // Return data from the API
  return data;
}
